import UserManagementContextPropsType from './ManagementContextPropTypes';

export const actions = {
  FETCH_COGNITO_USERS: 'FETCH_COGNITO_USERS',
  COGNITO_USERS_LOADED: 'COGNITO_USERS_LOADED',
  SET_COGNITO_USERS: 'SET_COGNITO_USERS',
  TENANTS_LOADED: 'TENANTS_LOADED',
  SET_TENANTS: 'SET_TENANTS',
  ROLES_LOADED: 'ROLES_LOADED',
  ROLE_DETAIL_LOADED: 'ROLES_LOADED',
  SET_ROLES: 'SET_ROLES',
  SET_ROLE_DETAIL: 'SET_ROLE_DETAIL',
  POLICIES_LOADED: 'POLICIES_LOADED',
  SET_POLICIES: 'SET_POLICIES',
  SET_POLICY_DETAIL: 'SET_POLICY_DETAIL',
  SET_POLICY_CONFIG_KEYS: 'SET_POLICY_CONFIG_KEYS',

  SET_DEFAULT_POLICY: 'SET_DEFAULT_POLICY',

  FETCHING_DATA: 'FETCHING_DATA',
  FETCHING_SUCCESS: 'FETCHING_SUCCESS',
  FETCHING_ERROR: 'FETCHING_ERROR',

  SET_MESSAGE: 'SET_MESSAGE',

  CLEAR_STATE: 'CLEAR_STATE',
};

export function reducer(
  state: any,
  action: any,
): UserManagementContextPropsType {
  switch (action.type) {
    case actions.FETCHING_DATA:
      return {
        ...state,
        loadingData: true,
      };
    case actions.CLEAR_STATE:
      return {
        ...action.payload,
      };
    case actions.FETCHING_SUCCESS:
      return {
        ...state,
        loadingData: false,
      };
    case actions.FETCHING_ERROR:
      return {
        ...state,
        loadingData: false,
        msg: action.payload.msg,
      };
    case actions.SET_COGNITO_USERS: {
      return {
        ...state,
        appUsersLoaded: true,
        appUsers: action.payload,
      };
    }
    case actions.SET_TENANTS: {
      return {
        ...state,
        fetchingData: false,
        tenantsLoaded: true,
        tenants: action.payload,
      };
    }
    case actions.SET_ROLES: {
      return {
        ...state,
        fetchingData: false,
        rolesLoaded: true,
        roles: action.payload,
      };
    }
    case actions.SET_ROLE_DETAIL: {
      return {
        ...state,
        fetchingData: false,
        roleDetailLoaded: true,
        roleDetail: action.payload,
      };
    }
    case actions.SET_POLICY_DETAIL: {
      return {
        ...state,
        policyDetailLoaded: true,
        policyDetail: action.payload,
      };
    }
    case actions.SET_POLICIES: {
      return {
        ...state,
        fetchingData: false,
        policiesLoaded: true,
        policies: action.payload,
      };
    }
    case actions.SET_DEFAULT_POLICY: {
      return {
        ...state,
        defaultPolicy: action.payload,
      };
    }
    case actions.SET_MESSAGE:
      return {
        ...state,
        msg: action.payload.msg,
      };
    case actions.SET_POLICY_CONFIG_KEYS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}
